/** Canonical social profile URLs — keep in sync with footer and Organization schema. */
export const SOCIAL_PROFILE_URLS = [
  "https://www.facebook.com/trekkingholidays",
  "https://www.instagram.com/montblanctreks",
  "https://x.com/montblanctreks",
] as const;
